import { collection, doc, getFirestore, onSnapshot, query, getDocs } from "firebase/firestore"
import getCollectionPath from '@/services/firestore/getCollectionPath'
import catalogueCommands from '@/commands/catalogueCommands'

const db = getFirestore()
const collectionName = 'offers/'

function docToInstance(document) {
  const data = document.data()
  if(data.attractivityParameters == undefined) {
    data.attractivityParameters = {
      price : {center: 100, variance: 50, qmin: 0, qmax: 100, linear: false, saturation: false},
      quality : {center: 100, variance: 50, qmin: 0, qmax: 100, linear: false, saturation: false},
      rse : {center: 100, variance: 50, qmin: 0, qmax: 100, linear: false, saturation: false},
      reputation : {center: 100, variance: 50, qmin: 0, qmax: 100, linear: false, saturation: false},
    }
  }
  return data ? new Offer(document.id, data.name, data.type, data.img, data.options, data.attractivityParameters,data.multiplier,data.available) : null
}

export default class Offer {
  constructor(id, name, type, img, options, attractivityParameters, multiplier = 1, available = true) {
    this.id = id
    this.name = name
    this.type = type
    this.img = img
    this.options = options
    this.attractivityParameters = attractivityParameters
    this.multiplier = multiplier
    this.available = available
  }
  
  static initOne() {
    let attractivityParameters = {
      price : {center: 100, variance: 50, qmin: 0, qmax: 100, linear: false, saturation: false},
      quality : {center: 100, variance: 50, qmin: 0, qmax: 100, linear: false, saturation: false},
      rse : {center: 100, variance: 50, qmin: 0, qmax: 100, linear: false, saturation: false},
      reputation : {center: 100, variance: 50, qmin: 0, qmax: 100, linear: false, saturation: false},
    }
    return new Offer(null, 'Nouvelle offre', 'service', 'service', [], attractivityParameters, 1,true)
  }

  async save() {
    const data = {
      name: this.name,
      type: this.type,
      img: this.img,
      options: this.options,
      attractivityParameters: this.attractivityParameters,
      multiplier: this.multiplier,
      available: this.available
    }

    if (this.id) {
      await catalogueCommands.offer.update(this.id, data)
    } else {
      const result = await catalogueCommands.offer.create(data)
      this.id = result.id
    }
    return this
  }
  async delete() {
    await catalogueCommands.offer.delete(this.id)
  }

  static async listenAll(callback) {
    const docsQuery = query(collection(db, await getCollectionPath(collectionName)))
    // L'abonnement est rendu à l'appelant : sans lui, quitter la page laissait
    // l'écoute Firestore ouverte pour toute la durée de la session.
    return onSnapshot(docsQuery, snapshot => {
      const list = []
      snapshot.forEach(document => {
        list.push(docToInstance(document))
      })
      callback(list)
    })
  }

  static async getAll(){
    let response = await getDocs(collection(db, await getCollectionPath(collectionName)))
    let list = []
    response.forEach(doc => {
        list.push(docToInstance(doc))
    })
    return list
  }
}
